import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Categories from './categories';
import Defaults from './defaults';

export default function DeductionSettings({ deductionCategories, defaultDeductions, features, options, paths }) {
  const [categories, setCategories] = useState(deductionCategories);

  return <React.Fragment>
    <div className="row">
      <div className="col-xs-12">
        <Categories
          categories={categories}
          deductionCategoriesPath={paths.deductionCategories}
          enableHouseDeductions={features.houseDeductions}
          enableTieredDeductions={features.tieredDeductions}
          onChange={setCategories}
        />
      </div>
    </div>

    <div className="row">
      <div className="col-xs-12">
        <Defaults
          categories={categories.filter(category => category.voucherCategory)}
          defaultDeductions={defaultDeductions}
          features={features}
          options={options}
        />
      </div>
    </div>
  </React.Fragment>;
}

DeductionSettings.propTypes = {
  deductionCategories: PropTypes.array,
  defaultDeductions: PropTypes.array,
  features: PropTypes.shape({
    houseDeductions: PropTypes.bool,
    tieredDeductions: PropTypes.bool,
  }).isRequired,
  options: PropTypes.object,
  paths: PropTypes.shape({
    deductionCategories: PropTypes.string
  }).isRequired,
};
